module.exports = __webpack_public_path__ + "media/newstyle/images/hero-background-mobile-f8639f6359fd6b4065cdedc341d6be27.png";